(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stt-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stt-mobile-purchase')) {
    class SttMobilePurchase extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.product-template__container');
        this.form = this.section?.querySelector('form[data-product-form]');
        this.primary = this.form?.querySelector('[data-add-to-cart]');
        if (!this.primary) return;
        this.submit = this.querySelector('[data-stt-submit]');
        this.edit = this.querySelector('[data-stt-edit]');
        this.price = this.querySelector('[data-stt-price]');
        this.net = this.querySelector('[data-stt-net]');
        this.netLabel = this.dataset.netLabel || '';
        this.variants = JSON.parse(this.querySelector('[data-stt-variants]').textContent);
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.hasOptions = !!this.form.querySelector('.single-option-selector');
        this.guideLabel = this.edit?.textContent.trim() || 'Auswahl ansehen';
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.refresh = () => this.update();
        this.form.addEventListener('change', () => requestAnimationFrame(this.refresh), options);
        this.form.addEventListener('input', this.refresh, options);
        document.addEventListener('focusin', this.refresh, options);
        document.addEventListener('focusout', () => requestAnimationFrame(this.refresh), options);
        window.addEventListener('resize', this.refresh, options);
        this.edit?.addEventListener('click', () => this.focusForm(), options);
        this.submit.addEventListener('click', () => {
          this.update();
          if (this.guideMode) {
            this.focusForm(this.form.querySelector('.single-option-selector'));
            return;
          }
          if (this.submit.disabled) return;
          const required = Array.from(this.form.querySelectorAll('[data-required-order-field]'));
          const missing = required.find(field => !field.value.trim() || field.getAttribute('aria-invalid') === 'true');
          const quantity = this.form.querySelector('[name="quantity"]');
          if (missing || (quantity && !quantity.checkValidity())) {
            this.focusForm(missing || quantity);
            return;
          }
          this.primary.click();
        }, options);
        this.positionObserver = new IntersectionObserver(this.refresh);
        this.positionObserver.observe(this.primary);
        this.stateObserver = new MutationObserver(this.refresh);
        this.stateObserver.observe(this.primary, { attributes: true, childList: true, subtree: true });
        this.bodyObserver = new MutationObserver(this.refresh);
        this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
        this.update();
      }
      focusForm(field) {
        const target = field || this.form.querySelector('.single-option-selector, [data-required-order-field], [name="quantity"]') || this.primary;
        this.hidden = true;
        target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        requestAnimationFrame(() => target.focus({ preventScroll: true }));
      }
      update() {
        const id = this.form.querySelector('[name="id"]')?.value;
        const variant = this.variants.find(item => String(item.id) === id);
        this.price.textContent = variant?.price || '';
        this.net.textContent = variant ? [this.netLabel, variant.net].filter(Boolean).join(' ') : '';

        const rect = this.primary.getBoundingClientRect();
        const primaryVisible = rect.top < window.innerHeight && rect.bottom > 0;
        const primaryBelow = rect.top >= window.innerHeight;
        this.guideMode = this.hasOptions && primaryBelow;

        const primaryLabel = this.primary.querySelector('[data-add-to-cart-text]')?.textContent.trim() || this.primary.textContent.trim();
        this.submit.textContent = this.guideMode ? this.guideLabel : primaryLabel;
        this.submit.disabled = this.guideMode ? false : (!variant || this.primary.disabled || this.primary.getAttribute('aria-disabled') === 'true');

        const active = document.activeElement;
        const editing = active?.matches('input, select, textarea, [contenteditable="true"]');
        const locked = getComputedStyle(document.body).overflow === 'hidden' || getComputedStyle(document.documentElement).overflow === 'hidden';
        this.hidden = !this.mobile.matches || primaryVisible || editing || locked;
      }
      disconnectedCallback() {
        this.events?.abort();
        this.positionObserver?.disconnect();
        this.stateObserver?.disconnect();
        this.bodyObserver?.disconnect();
      }
    }
    customElements.define('stt-mobile-purchase', SttMobilePurchase);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stt-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stt-product-details')) {
    customElements.define('stt-product-details', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        const source = this.querySelector('[data-stt-description]');
        if (!source) return;
        const nodes = Array.from(source.childNodes);
        const headings = nodes.filter(node => node.nodeType === 1 && node.tagName === 'H2');
        if (headings.length < 2) return;
        const first = nodes.indexOf(headings[0]);
        const preface = nodes.slice(0, first);
        const hasPreface = preface.some(node => node.textContent.trim() || node.nodeType === 1);
        const fragment = document.createDocumentFragment();
        let content;
        if (hasPreface) {
          const details = document.createElement('details');
          details.open = true;
          const summary = document.createElement('summary');
          summary.textContent = this.dataset.overview;
          content = document.createElement('div');
          content.className = 'product-single__description rte';
          details.append(summary, content);
          fragment.append(details);
        }
        const legacy = preface.find(node => node.nodeType === 1 && node.tagName === 'DIV' && Array.from(node.querySelectorAll('strong')).map(el => el.textContent.trim()).join('|') === 'Ihre Vorteile auf einen Blick|Lieferzeit|Ohne Abo|Software inklusive|Fachhändler & Support');
        if (legacy) {
          legacy.removeAttribute('style');
          legacy.querySelectorAll('[style]').forEach(el => el.removeAttribute('style'));
          legacy.classList.add('stt-description-benefits');
        }
        nodes.forEach(node => {
          if (node.nodeType === 1 && node.tagName === 'H2') {
            const details = document.createElement('details');
            details.open = !content;
            const summary = document.createElement('summary');
            while (node.firstChild) summary.append(node.firstChild);
            content = document.createElement('div');
            content.className = 'product-single__description rte';
            details.append(summary, content);
            fragment.append(details);
          } else if (content) {
            content.append(node);
          }
        });
        this.replaceChildren(fragment);
        this.dataset.enhanced = 'true';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stt-purchase-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stt-purchase-info')) {
    customElements.define('stt-purchase-info', class extends HTMLElement {
      connectedCallback() {
        this.container = this.closest('[data-section-type="product"]');
        if (!this.container || this.onVariant) return;
        this.onVariant = event => this.updateVariant(event.detail.variant);
        this.container.addEventListener('variantChange', this.onVariant);
        const selected = this.querySelector('[data-stt-variant-info]:not([hidden])');
        const select = this.container.querySelector('select[name="id"]');
        if (selected && select) {
          const option = Array.from(select.options).find(item => item.value === selected.dataset.sttVariantInfo);
          if (option) this.updateAdvice(selected.querySelector('.stt-package')?.textContent?.split(':').slice(1).join(':').trim() || '');
        }
      }
      disconnectedCallback() {
        this.container?.removeEventListener('variantChange', this.onVariant);
        this.onVariant = null;
      }
      updateAdvice(title) {
        this.container.querySelectorAll('[data-stt-advice-link]').forEach(link => {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('produkt', link.dataset.productTitle + (title && title !== 'Default Title' ? ' – ' + title : ''));
          link.href = url.href;
        });
      }
      updateVariant(variant) {
        let selected;
        this.querySelectorAll('[data-stt-variant-info]').forEach(panel => {
          panel.hidden = !variant || panel.dataset.sttVariantInfo !== String(variant.id);
          if (!panel.hidden) selected = panel;
        });
        this.querySelector('[data-stt-variant-missing]').hidden = !!selected;
        this.querySelector('[data-stt-availability-live]').textContent = selected ? selected.querySelector('strong').textContent : this.querySelector('[data-stt-variant-missing]').textContent;
        this.updateAdvice(variant?.title || '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
